import React, { useCallback, useEffect, useState } from 'react';
import JobBoardPagination from '../../JobBoard/JobBoardPagination';
import CouponRow from './CouponRow';
import EmptyCoupon from './EmptyCoupon';
import {
  getActiveCoupons,
  getInactiveCoupons,
} from '../../../api/coupon/coupon.api';
import { useT } from '@repo/common';

const CouponsList = ({ currentFilter, onCopy, $isMobile }) => {
  const t = useT();
  const [couponsList, setCouponsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchHistory = useCallback(async () => {
    setIsLoading(true);
    try {
      const page = currentPage - 1;
      const data =
        currentFilter === 'Active'
          ? await getActiveCoupons(page)
          : await getInactiveCoupons(page);

      setCouponsList(data.content || []);
      setTotalPages(data.totalPages || 1);
    } catch (error) {
      console.error('쿠폰 내역을 불러오지 못했습니다.', error);
    } finally {
      setIsLoading(false);
    }
  }, [currentFilter, currentPage]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  useEffect(() => {
    setCurrentPage(1);
  }, [currentFilter]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  return (
    <div className='w-full flex flex-col overflow-hidden bg-transparent gap-10 relative z-10'>
      <div className='flex flex-col gap-4 w-full'>
        {isLoading ? (
          <div className='w-full p-10 flex justify-center text-text-placeholder typo-b14'>
            {t('Loading...', '불러오는 중...')}
          </div>
        ) : couponsList.length === 0 ? (
          <EmptyCoupon currentFilter={currentFilter} />
        ) : (
          couponsList.map((item) => (
            <CouponRow
              key={item.invoiceNo}
              item={item}
              currentFilter={currentFilter}
              onCopy={onCopy}
              $isMobile={$isMobile}
            />
          ))
        )}
      </div>

      {!isLoading && couponsList.length > 0 && (
        <JobBoardPagination
          isMyPage
          current={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default CouponsList;
